module.exports = __webpack_public_path__ + "img/pro-m-slider24.119811f0.png";